<template>
  <v-container id="dashboard" fluid tag="section">
    <component v-for="widget in widgets" :key="widget.name" :is="widget.type" :data="widget.propsData"
      v-bind="widget.propsData"></component>
  </v-container>
</template>

<script>
import dashboardMessage from "@/widget/dashboardMessage.vue";
import dashboardTesseramento from "@/widget/dashboardTesseramento.vue";
import getUserStats from "@/widget/getUserStats.vue";
import listCertificati from "@/widget/listCertificati.vue";
import listOrdini from "@/widget/listOrdini.vue";
import listEventi from "@/widget/listEventi.vue";
import listProducts from "@/widget/listProducts.vue";
import listTessere from "@/widget/listTessere.vue";

export default {
  name: "DashboardDashboard",
  components: {
    dashboardMessage,
    dashboardTesseramento,
    getUserStats,
    listCertificati,
    listOrdini,
    listProducts,
    listTessere,
    listEventi,
  },
  data() {
    return {};
  },
  computed: {
    widgets: function () {
      let configuredWidget = [];
      for (let widget of window.systemData.DASHBOARD) {
        if (widget === "messages") {
          configuredWidget.push({
            name: "messages",
            type: "dashboard-message",
          });
        }
        if (widget === "ordini2pay") {
          configuredWidget.push({
            name: "ordini_2pay",
            type: "list-ordini",
            propsData: { hideEmpty: true, card: true, mode: "2pay" },
          });
        }
        if (widget === "products") {
          configuredWidget.push({
            name: "products",
            type: "list-products",
          });
        }
        if (widget === "tesseramento") {
          configuredWidget.push({
            name: "tesseramento",
            type: "dashboard-tesseramento",
          });
        }
        if (widget === "stats") {
          configuredWidget.push({
            name: "stats",
            type: "get-user-stats",
          });
        }
        if (widget === "certificati2approve") {
          configuredWidget.push({
            name: "certificati_2approve",
            type: "list-certificati",
            propsData: { hideEmpty: true, card: true, mode: "2approve" },
          });
        }
        if (widget === "ordini2approve") {
          configuredWidget.push({
            name: "ordini_2approve",
            type: "list-ordini",
            propsData: { hideEmpty: true, card: true, mode: "2approve" },
          });
        }
        if (widget === "ordini2evade") {
          configuredWidget.push({
            name: "ordini_2evade",
            type: "list-ordini",
            propsData: { hideEmpty: true, card: true, mode: "2evade" },
          });
        }

        if (widget === "events") {
          configuredWidget.push({
            name: "events",
            type: "list-eventi",
            auth: true,
            propsData: { auth: true },
          });
        }
      }
      return configuredWidget;
    },
  },
};
</script>
